import { gql } from '@apollo/client'

export default gql(`
  query ( $limit: Int ){
    listSports(
        limit: $limit
      ) {
        items{
          id
          title
          externalId
        }
    }
  }`
)
